import Wizard from './Wizard';
import Page from './Page';
import { UserIsAuthenticated, siteTitle } from '../';

const WizardRoutes = {
		wizard: {
				path: '/wizard',
				label: 'Wizard',
				title: `${siteTitle} - Wizard`,
				component: UserIsAuthenticated(Wizard),
				childRoutes: [{
						path: ':page',
						component: Page,
						title: 'Wizard Page',
						label: 'Wizard Page'
				}]
		}
};

export { WizardRoutes, Wizard };



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/index.ts